/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './getFeedGenerator.defs'
export { main as default } from './getFeedGenerator.defs'
